import { RadialBlurFilter as PixiRadialBlur } from 'pixi-filters'
import { useProjectStore } from '@/store/project-store'
import AudioIntensityAnalyzer from '@/audio/AudioIntensityAnalyzer'
import { SeratoFilter, EffectState } from '@/pixi/filters/types'
import useAudioEngine from '@/composables/UseAudioEngine'
const { audioBackgroundIntensity } = useAudioEngine()

export class RadialBlurFilter extends PixiRadialBlur implements SeratoFilter {
  protected projectStore = useProjectStore()
  
  constructor (private effectState: EffectState) {
    super()
  }

  public updateUniforms () {
    const canvasDimensions = this.projectStore.resolution
    const audioIntensity = this.effectState.audioReactivityEnabled
      ? AudioIntensityAnalyzer.getAudioIntensity(this.uniforms.audioFrequencyData, audioBackgroundIntensity.value) : 1

    this.angle = Math.floor(audioIntensity * this.effectState.intensity * 24)

    this.center = [canvasDimensions.width / 2, canvasDimensions.height / 2]
    this.radius = Math.sqrt(Math.pow(canvasDimensions.width, 2) + Math.pow(canvasDimensions.height, 2)) / 2
    this.kernelSize = 21
  }
}
